import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { lastValueFrom } from 'rxjs';
import { BusyIndicatorMessageManager } from '../../../Busy-Indicator';
import { TaxAccessSyncLogRepository } from '../taxAccessSyncLog.repository';
import { IWeissmanModalComponent } from '../../../Compliance/WeissmanModalService';
import { TaxAccessSyncLogDetailsGridComponent } from './taxAccessSyncLogDetailsGrid.component';

export interface TaxAccessSyncLogDetailsParams {
    summaryLogId: number;
}

@Component({
    selector: 'tax-access-sync-log-details-modal',
    templateUrl: './taxAccessSyncLogDetailsModal.component.html',
    styleUrls: ['./taxAccessSyncLogDetailsModal.component.scss'],
    standalone: false,
    encapsulation: ViewEncapsulation.None
})
export class TaxAccessSyncLogDetailsModalComponent implements OnInit, IWeissmanModalComponent<TaxAccessSyncLogDetailsParams, void> {
    constructor(
        private readonly _bsModalRef: BsModalRef,
        private readonly _taxAccessSyncLogRepository: TaxAccessSyncLogRepository) {
    }

    @ViewChild('taxAccessSyncLogDetailsGrid') taxAccessSyncLogDetailsGrid: TaxAccessSyncLogDetailsGridComponent;

    busyIndicatorMessageManager: BusyIndicatorMessageManager<string> = new BusyIndicatorMessageManager<string>();

    params: TaxAccessSyncLogDetailsParams;
    result: void;

    taxAccessSyncDiagnosticsDetail: Core.TaxAccessSyncDiagnosticsDetailModel;

    readonly runTypeLabels: { [key: number]: string } = {
        [Core.TaxAccessSyncRunTypeEnum.Nightly]: 'Nightly',
        [Core.TaxAccessSyncRunTypeEnum.Baseline]: 'Baseline'
    };

    readonly runStatusLabels: { [key: number]: string } = {
        [Core.TaxAccessSyncRunStatusEnum.Running]: 'Running',
        [Core.TaxAccessSyncRunStatusEnum.Succeeded]: 'Succeeded',
        [Core.TaxAccessSyncRunStatusEnum.PartiallyFailed]: 'Partially Failed',
        [Core.TaxAccessSyncRunStatusEnum.Failed]: 'Failed'
    };

    async ngOnInit(): Promise<void> {
        const busyMsgId = 'loading';
        this.busyIndicatorMessageManager.add('Loading Tax Access Sync Log Details', busyMsgId);

        const searchParams: Core.TaxAccessSyncDiagnosticsDetailSearchModel = {
            summaryLogId: this.params.summaryLogId,
            pagination: {
                skip: 0,
                take: 0
            }
        };

        try {
            this.taxAccessSyncDiagnosticsDetail = await lastValueFrom(this._taxAccessSyncLogRepository.getDetail(searchParams));
        } finally {
            this.busyIndicatorMessageManager.remove(busyMsgId);
        }
    }

    cancel(): void {
        this._bsModalRef.hide();
    }
}
